import * as React from 'react';
import { Link } from 'react-router-dom';
import { debounce, Cancelable } from 'lodash';
import { generateColumns } from 'common/helpers/utils';
import { PaginatedTable } from 'features/pagination/components/PaginatedTable';
import { SubmitButton } from 'common/components';
import { Organisation } from 'features/organisation/models/organisationModels';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { getPotentialExecutivesSuccess } from 'features/organisation/actions/organisationActions';
import {
    Antd3Form,
    Antd3FormProps,
    Antd3Search,
    StyledAntd3Form,
} from 'common/components/deprecated/antd3';
import { EditPaths } from 'features/edit/models/editModel';
import { InviteOrganisationProps } from '../containers/InviteOrganisationContainer';

interface InviteOrganisationState {
    selectedOrganisationIds: number[];
}

type AddOrganisationProps = InviteOrganisationProps & Antd3FormProps;

const addOrganisationColumns = [
    {
        title: 'Organisation',
        key: 'name',
        render: (name: string, { id }: Organisation) => (
            <Link to={`${EditPaths.Organisations}/${id}/details`}>{name}</Link>
        ),
    },
];

class AddOrganisationComponent extends React.Component<
    AddOrganisationProps,
    InviteOrganisationState
> {
    public state: InviteOrganisationState = {
        selectedOrganisationIds: [],
    };

    private makePaginationRequest = () =>
        this.props.paginationRequest({
            view: PaginationView.AddOrganisation,
            pagination: {
                current: 1,
            },
            paginationSuccessCallback: getPotentialExecutivesSuccess,
        });

    private handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        this.props.invitePotentialExecutivesRequest(this.state.selectedOrganisationIds);
    };

    private searchOrganisations = (value: string) => {
        this.props.saveFilters({
            paginatedView: PaginationView.AddOrganisation,
            values: {
                name: value,
            },
        });

        this.makePaginationRequest();
    };

    private debouncedSearch: ((value: string) => void) & Cancelable = debounce(
        (value) => this.searchOrganisations(value),
        300,
    );

    private onSelectChange = (selectedOrganisationIds: number[]) =>
        this.setState({ selectedOrganisationIds });

    public componentWillUnmount = () => this.props.clearFilters(PaginationView.AddOrganisation);

    public render(): JSX.Element {
        const {
            selectedOrganisationIds: { length },
        } = this.state;

        const buttonText = `Add ${length > 1 ? `organisations (${length})` : 'organisation'}`;

        return (
            <StyledAntd3Form onSubmit={this.handleSubmit} header="Add Organisation" bigHeader>
                <Antd3Form.Item>
                    <Antd3Search
                        form={this.props.form}
                        id="Search organisations"
                        getFieldDecoratorOptions={{}}
                        placeholder="Search organisations"
                        onChange={({ target: { value } }) => this.debouncedSearch(value)}
                    />
                </Antd3Form.Item>
                <PaginatedTable
                    view={PaginationView.AddOrganisation}
                    paginationSuccessCallback={getPotentialExecutivesSuccess}
                    data={this.props.potentialExecutives}
                    columns={generateColumns(addOrganisationColumns)}
                    emptyText="No organisations found"
                    rowSelection={{
                        selectedRowKeys: this.state.selectedOrganisationIds,
                        onChange: this.onSelectChange,
                    }}
                />
                <SubmitButton
                    disabled={this.state.selectedOrganisationIds.length === 0}
                    value={buttonText}
                />
            </StyledAntd3Form>
        );
    }
}

const AddOrganisationForm = Antd3Form.create({})(AddOrganisationComponent);

export const AddOrganisation = AddOrganisationForm;
